import { Component,ChangeDetectorRef } from '@angular/core';
import { Router }  from '@angular/router';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service';
import { Location } from '@angular/common'

declare const gapi: any;
export interface Tile {
	color: string;
	cols: number;
	text: string;
  }
  export interface wrtMenu {
	text: string;
	icon:string;
	link:string;
  }
  export interface icbMenu {
	text: string;
	icon: string;
	link: string;
  }
  export interface focMenu {
	text: string;
	icon: string;
	link: string;
  }


@Component({
	selector: 'app-home',
	styles: [require('./home.component.scss')],
	template: require('./home.component.html'),
	providers: [HttpService,SessionHandler]
})

export class HomeComponent {
	tiles: Tile[] = [
		{ text: 'Web Return tool', cols: 6,  color: 'white' },
		{ text: 'Internet Call Booking', cols: 6,  color: 'white' },
		{ text: 'FOC', cols: 6,  color: 'white' },

	  ];
	  wrtData: wrtMenu[] = [
		{
		  text: 'Dashboard', icon: 'space_dashboard', link:'#/app/wrt-dashboard'},
		{ text: 'New Request', icon: 'note_add', link: 'app/new-request'},
		{ text: 'User Manual', icon: 'local_library', link: 'app/user-manual'},
		{ text: 'Inspection', icon: 'find_in_page', link: 'app/inspection'},
		{ text: 'Approval Matrix', icon: 'inventory', link: 'app/approval-matrix'},

	  ];
	  icbData: icbMenu[] = [
		{
		  text: 'Dashboard', icon: 'space_dashboard', link: 'app/icb/dashboard'
		},
		{
		  text: 'Technical Request', icon: 'note_add', link: 'app/icb/technical-request' },
	  ];
	  focData: focMenu[] = [
		{
			text: 'Dashboard', icon: 'space_dashboard', link:'/app/foc_dashboard'},
		  { text: 'New Request', icon: 'note_add', link: '/app/focrequests/create'},
		  { text: 'Approval Matrix', icon: 'inventory', link: '/app/foc_admin'},
  
	  ]

	userData: any;
	isApprover: boolean = false;
    isFS: boolean = false;
    isAdmin: boolean = false;
    isIcb: boolean = false;
    isOTD: boolean = false;
    isOrderDesk: boolean = false;
	isFOCUser: boolean = false;
	isFOCAdmin: boolean = false;
isFOCApprover: boolean = false;
	  


	constructor(private router: Router,private sessionHandler:SessionHandler,private location: Location){
		let allAccess=JSON.parse(this.sessionHandler.getItem('allAccess'));
		this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
		


		if (this.userData && this.userData.role && this.userData.role.length > 0) {
            
            if (this.userData.role.includes('APPROVER') || this.userData.role.includes('ADMIN')) {
                this.isApprover = true;
            }
            if (this.userData.role.includes('EMPLOYEE') || this.userData.role.includes('ADMIN')) {
                this.isFS = true;
            }
            if (this.userData.role.includes('ADMIN')) {
                this.isAdmin = true;
            }
            if (this.userData.role.includes('OTD_APPROVER')) {
                this.isOTD = true;
            }
            if (this.userData.role.includes('ORDER_DESK_AGENT')) {
                this.isOrderDesk = true;
            }
			this.isFOCUser =
    this.userData.role.includes('FOC_ADMINISTRATOR') ||
    this.userData.role.includes('FOC_APPROVER') ||
    this.userData.role.includes('FOC_EMPLOYEE') ||
    this.userData.role.includes('FOC_HR');

  this.isFOCAdmin = this.userData.role.includes('FOC_ADMINISTRATOR');
  this.isFOCApprover = this.userData.role.includes('FOC_APPROVER');
		}

		console.log(allAccess);
		if(!allAccess){
			this.location.back()		
		}
	}
    ngOnInit () {}
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/home/home.component.ts